import type { EditableSummaryEntity } from '@platform/timeline';

export type CurrentArtifactContext = {
  artifactId: string;
  revision: number;
  profileSlug: string;
};

export function toCurrentArtifactContext(params: {
  artifactId: string | null;
  profileSlug: string;
  selectedRevision: number | null;
  latestRevision: number | null;
  editableEntities: EditableSummaryEntity[];
}): CurrentArtifactContext | null {
  const { artifactId, profileSlug, selectedRevision, latestRevision, editableEntities } = params;

  if (!artifactId || artifactId.trim() === '') return null;
  const trimmedArtifactId = artifactId.trim();

  const matchingEditableEntities = editableEntities.filter(
    (e) => typeof e.props?.artifact_id === 'string' && e.props.artifact_id === trimmedArtifactId
  );
  const latestEditable = matchingEditableEntities.length
    ? matchingEditableEntities.reduce((a, b) => (a.timestamp > b.timestamp ? a : b))
    : null;

  const revisionFromEntity =
    typeof latestEditable?.props?.artifact_revision === 'number'
      ? latestEditable.props.artifact_revision
      : null;

  const revision = revisionFromEntity ?? selectedRevision ?? latestRevision ?? null;
  if (!revision || revision <= 0) return null;

  return {
    artifactId: trimmedArtifactId,
    revision,
    profileSlug,
  };
}
